import React from 'react'
import PropTypes from 'prop-types';
import RequiredInput from '../elements/required-input'

const FirstNameInput = ({ model, label = 'First name', readOnly, controlId, errorLabel }) => {
  return (
    <RequiredInput label={label}
                   placeholder="First name"
                   model={model}
                   readOnly={readOnly}
                   controlId={controlId}
                   errorLabel={errorLabel} />
  );
};

FirstNameInput.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  controlId: PropTypes.string,
  errorLabel: PropTypes.string,
};

FirstNameInput.defaultProps = {
  model: '.first_name',
  label: 'First name',
  readOnly: false,
  controlId: 'firstName',
  errorLabel: 'user_first_name'
};

export default FirstNameInput;



// WEBPACK FOOTER //
// ./src/components/common/form/user/user-first-name-input.jsx